import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'gfFilterRangeTo'
})
export class GfFilterRangeTo implements PipeTransform {
    transform(rangeValue: string): string {
        var arrValues = rangeValue.split('|-|');
        return (arrValues.length > 1 && arrValues[1] != '') ? arrValues[1] : '';
    }
};